// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixLocation from 'wix-location';

export function buttonRegister_click(event) {
	let cost = $w("#formCost").selectedIndex

	if ((!$w("#formAddr").valid) ||
	   (!$w("#formCost").valid) ||
	   (!$w("#formEmail").valid) ||
	   (!$w("#formName").valid)
	 ) {
		   return
	   }
	
	if (cost == "0") {
		wixLocation.to('https://pages.greeninvoice.co.il/payments/links/4df46efb-67ae-443b-9f64-68361568fe21');
	} else if (cost == "1") {
		wixLocation.to('https://pages.greeninvoice.co.il/payments/links/30b8e57b-e450-4f0c-9a8c-d247404dbc89')
	} else if (cost == "2") {
		wixLocation.to('https://pages.greeninvoice.co.il/payments/links/e330033a-e730-4dc3-89b6-5a7d886abfd5')
	} else if (cost == "3") {
		wixLocation.to('https://pages.greeninvoice.co.il/payments/links/4c199364-0a80-4487-91ca-cfdbb16bc9e4')
	}
}